// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ScoreTodayRouteImport } from './routes/score.today'
import { Route as DevSampleReportRouteImport } from './routes/dev.sample-report'
import { Route as DevPreviewMyReportRouteImport } from './routes/dev.preview-my-report'
import { Route as DevPreviewAnnualSummaryRouteImport } from './routes/dev.preview-annual-summary'
import { Route as AdminTestRouteImport } from './routes/admin.test'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
            id: '/confirm-email',path: '/confirm-email',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ScoreTodayRoute = ScoreTodayRouteImport.update({
            id: '/score/today',path: '/score/today',getParentRoute: () => rootRouteImport
          })
const DevSampleReportRoute = DevSampleReportRouteImport.update({
            id: '/dev/sample-report',path: '/dev/sample-report',getParentRoute: () => rootRouteImport
          })
const DevPreviewMyReportRoute = DevPreviewMyReportRouteImport.update({
            id: '/dev/preview-my-report',path: '/dev/preview-my-report',getParentRoute: () => rootRouteImport
          })
const DevPreviewAnnualSummaryRoute = DevPreviewAnnualSummaryRouteImport.update({
            id: '/dev/preview-annual-summary',path: '/dev/preview-annual-summary',getParentRoute: () => rootRouteImport
          })
const AdminTestRoute = AdminTestRouteImport.update({
            id: '/admin/test',path: '/admin/test',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRoute,ConfirmEmailRoute: ConfirmEmailRoute,CookiesRoute: CookiesRoute,DisclaimerRoute: DisclaimerRoute,ForgotPasswordRoute: ForgotPasswordRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,TermsRoute: TermsRoute,AdminTestRoute: AdminTestRoute,DevPreviewAnnualSummaryRoute: DevPreviewAnnualSummaryRoute,DevPreviewMyReportRoute: DevPreviewMyReportRoute,DevSampleReportRoute: DevSampleReportRoute,ScoreTodayRoute: ScoreTodayRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)